
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class CompanyTaskService {

   
    static DeletePunches(ActionType, CompanyCode, email) {

        return axios.post(`${BaseUrl}CompanyTask?ActionType=${ActionType}&CompanyCode=${CompanyCode}&email=${email}`);
    }

}


// WEBPACK FOOTER //
// ./src/Services/CompanyTaskService/companyTaskService.js